module.exports = __webpack_public_path__ + "assets/img/member_vip_n.dfc7b0c9.png";